import type { CategoryBanner } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import Link from 'next/link'
import { type FC } from 'react'
import type { Settings } from 'react-slick'
import Slider from 'react-slick'
import ImageOptimize from '../ImageOptimize'

interface Props {
  data: CategoryBanner[]
}
export const BannerProductListing: FC<Props> = ({ data }: Props) => {
  const settings: Settings = {
    slidesToScroll: 1,
    arrows: false,
    infinite: true,
    speed: 800,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    variableWidth: false,
  }
  const settingsNonSlider: Settings = {
    swipe: false,
    slidesToShow: 1,
    infinite: false,
    variableWidth: false,
    draggable: false,
  }

  return (
    <>
      {data && data.length > 0 ? (
        <section className='categoryBanner w-full px-2 mb-4'>
          <div className='sliderCate w-full'>
            {data.length > 0 ? (
              <Slider {...settings} className=''>
                {data
                  ?.sort((a, b) => a.order - b.order)
                  .map((e, i) => (
                    <Link
                      className='block w-full overflow-hidden rounded-lg'
                      href={e.path || ''}
                      key={i}
                    >
                      <ImageOptimize
                        src={e.image || ''}
                        width={404}
                        height={108}
                        alt={getTranslate(e.name)}
                        priority
                        className='h-auto w-full'
                      />
                    </Link>
                  ))}
              </Slider>
            ) : (
              <Slider
                {...settingsNonSlider}
                className='non-slick ml-0 mr-auto flex w-full'
              >
                {data
                  ?.sort((a, b) => a.order - b.order)
                  .map((e, i) => (
                    <Link
                      className='block w-full overflow-hidden rounded-lg'
                      href={e.path || ''}
                      key={i}
                    >
                      <ImageOptimize
                        src={e.image || ''}
                        width={404}
                        height={108}
                        alt={getTranslate(e.name)}
                        className='h-auto w-full'
                        priority
                      />
                    </Link>
                  ))}
              </Slider>
            )}
          </div>
        </section>
      ) : (
        ''
      )}
    </>
  )
}
